import React from 'react';
import Button, { ILink } from 'tbk-components/src/components/Button';
import { useTranslation } from 'react-i18next';

export interface ContactInfo {
	tollFree?: string;
	telephone?: string;
	fax?: string;
	email?: string;
}

export interface IOfficeInfoProps {
	/**
	 * Office location
	 */
	location?: string;
	/**
	 * Office address
	 */
	address_line_1?: string;
	address_line_2?: string;
	/**
	 * Office official website
	 */
	website?: string;
	toll_free?: string;
	telephone?: string;
	fax?: string;
	email?: string;
	/**
	 * Is this office location the headquarter?
	 */
	isHeadquarter?: boolean;
	/**
	 * @noUI
	 */
	showAsHeadOffice?: boolean;
}

const OfficeInfo: React.FC<IOfficeInfoProps> = ({
	location,
	address_line_1,
	address_line_2,
	website,
	toll_free,
	telephone,
	fax,
	email,
	isHeadquarter,
	showAsHeadOffice,
}) => {
	const { t } = useTranslation();

	return (
		<div className="office-info__container">
			{showAsHeadOffice && (
				<span className="d-block office-info__location">
					{t('Headquarter')}
				</span>
			)}
			{location && !showAsHeadOffice && (
				<span className="d-block office-info__location">
					{location}
				</span>
			)}
			{address_line_1 && (
				<span className="d-block office-info__address">
					{address_line_1}
				</span>
			)}
			{address_line_2 && (
				<span className="d-block office-info__address">
					{address_line_2}
				</span>
			)}
			{website && (
				<div>
					<a href={website}></a>
					<Button
						href={website}
						label={t('Website')}
						target="_blank"
						className="btn-link office-info__website"
						onClick={(e) => {
							e.stopPropagation();
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') e.stopPropagation();
						}}
					/>
				</div>
			)}
			<div className="office-info__contact">
				{toll_free && (
					<>
						<span>{t('Toll Free')}: </span>
						<span>{toll_free}</span>
					</>
				)}
				{telephone && (
					<>
						<span>{t('Telephone')}: </span>
						<span>{telephone}</span>
					</>
				)}
				{fax && (
					<>
						<span>{t('Fax')}: </span>
						<span>{fax}</span>
					</>
				)}
				{email && (
					<>
						<span>{t('Email')}: </span>
						<a
							href={`mailto:${email}`}
							title={email}
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							{email}
						</a>
					</>
				)}
			</div>
		</div>
	);
};

export default OfficeInfo;
